module.exports = __webpack_public_path__ + "img/highlight-banner-cjdr.4381c232.png";